<template>
  <div class="pdf-preview-item-group "
       :id="itemGroup.id"
       v-if="!itemGroup.is_deleted">
    <div class="content-row">
      <div class="item-no left">
        <span>{{ section.order_no.toString().padStart(2, '0') }}{{ itemGroup.item_prefix }}</span>
      </div>
      <div class="item-description-wrapper">
      <span class="item-description"
            v-html="replaceItemNo(itemGroup.printed_description)"></span>
      </div>
      <div :class="['item-price', {'small': price.length >= 9}]"
           v-for="(price, idx) in prices"
           :key="idx">
        {{ price }}
      </div>
      <div class="item-no right">{{ section.order_no.toString().padStart(2, '0') }}{{ itemGroup.item_prefix }}</div>
    </div>

    <div class="content-row"
         v-if="itemGroup.printed_remarks">
      <div class="item-no left"></div>
      <div class="item-description-wrapper remarks"
           v-html="replaceItemNo(itemGroup.printed_remarks)">
      </div>
      <div class="item-price"
           v-for="(c, idx) in categories"
           :key="idx"></div>
      <div class="item-no right"></div>
    </div>
  </div>
</template>

<script>
import {computed} from "@vue/composition-api";
import _ from "lodash";

export default {
  name: 'ItemGroup',
  props: {
    section: Object,
    subSection: Object,
    itemCategories: Array,
    itemGroup: Object,
    items: Array,
  },
  setup(props) {
    const categories = computed(() => {
      let c = props.itemCategories.map((i) => i.suffix);
      if (c.length === 0) {
        c = ['A'];
      }

      return c
    })
    const prices = computed(() => {
      let categoryMap = {};
      if (props.itemCategories) {
        _.forEach(props.itemCategories, (c) => {
          categoryMap[c.id] = c;
        })
      }

      let price_map = {};
      if (props.itemGroup) {
        props.items.forEach((item) => {
          let suffix = item.category ? categoryMap[item.category].suffix : 'A';
          price_map[suffix] = item.value.toLocaleString('en-US');
        })
      }

      return categories.value.map((c) => {
        return price_map[c] || '-';
      });
    })

    const replaceItemNo = function (str) {
      return str.replaceAll(/({{[0-9]+}})/g, (match) => {
        let withoutBrackets = match.replace('{{', '').replace('}}', '')

        return `${props.section.order_no.toString().padStart(2, '0')}${withoutBrackets.padStart(3, '0')}`
      })
    };

    return {
      categories,
      prices,
      replaceItemNo,
    }
  }
}
</script>
